import { Text } from '@tonic-one/react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import i18nMap from 'src/mapping/i18nMap.json';
import { useDashboardServicesStore } from 'src/models/useDashboardServicesModel';
import { generateRedirectUrlToLog } from 'src/pages/Log/shared';
import { getServiceNamesByValues } from 'src/utils/service';
import { formatTableTopX, replaceTableData } from 'src/utils/table';

import { ThreatType } from '../../../../utils/enums';
import TableTemplate from '../../Charts/TableTemplate';
import DashboardCard from '../../Layout/DashboardCard';
import RedirectLink from '@Components/RedirectLink';
import { LogTypeEnum, SecurityFilterName } from '@Types/log';

function SecurityRiskSpamDetection(props: { data: any; day: string }) {
  const { t } = useTranslation();
  const servicesModel = useDashboardServicesStore();

  const config = [
    { width: '50%', grow: 1, align: 'left', tooltip: true },
    { width: '30%', grow: 0, align: 'right' },
  ];
  const header = [
    t('dashboard.chart.column.category'),
    t('dashboard.chart.column.detections'),
  ];

  const spamTypeMap = new Map<string, string>(
    Object.entries(i18nMap['spamType'].frontendMap)
  );

  const data = formatTableTopX(
    props.data?.security_risk_scanSpamBlockingByType?.[props.day],
    ['key', 'doc_count'],
    t
  ).map((row) => [
    row[0],
    row[1] === 0 ? (
      0
    ) : (
      <RedirectLink
        href={`logs?${generateRedirectUrlToLog(
          [
            {
              field: 'securityFilterName',
              values: [SecurityFilterName.AdvancedSpamProtection],
              type: 'terms',
            },
            {
              field: 'threatType',
              values: [
                ThreatType.BEC,
                ThreatType.Spoofing,
                ThreatType.MaliciousFile,
                ThreatType.Spam,
                ThreatType.Ransomware,
                ThreatType.Phishing,
              ],
              type: 'terms',
            },
            {
              field: 'spamCategory',
              values: [row[0] as string],
              type: 'terms',
            },
            {
              field: 'scanSource',
              values: getServiceNamesByValues(servicesModel.enabledServices),
              type: 'terms',
            },
          ],
          props.day,
          LogTypeEnum.DETECTION
        )}`}
      >
        <Text>{row[1]}</Text>
      </RedirectLink>
    ),
  ]);

  replaceTableData(data, spamTypeMap, 0, t);

  return (
    <DashboardCard title={t('dashboard.chart.title.atpSpamDetection')}>
      <TableTemplate config={config} header={header} data={data} />
    </DashboardCard>
  );
}

export default React.memo(SecurityRiskSpamDetection);
